export default "__VITE_ASSET__BQbyNW3___"